import moment from 'moment';
import Cookies from 'js-cookie';
import { callApi } from '../../utils';
import { setBookedEntertainments } from './bookedEvents';
import {
  REQUEST_BOOKED_ENTERTAINMENTS,
  RECEIVE_BOOKED_ENTERTAINMENTS,
  SET_BOOKED_ENTERTAINMENTS_FAILURE,
  CLEAR_BOOKED_ENTERTAINMENTS_ERROR_MESSAGE,
  SET_SELECTED_NUM_OF_GUESTS,
} from '../constants/bookedEntertainments';

const filterForBookedEventsOfThisBooking = (bookedActivities) => {
  const arrivalDate = Cookies.get('_arrivalDate');
  return bookedActivities.filter(({ Time }) => moment(Time).isSameOrAfter(arrivalDate, 'day'));
};

const requestBookedEntertainments = () => ({
  type: REQUEST_BOOKED_ENTERTAINMENTS,
});

export const receiveBookedEntertainments = bookedEntertainments => ({
  type: RECEIVE_BOOKED_ENTERTAINMENTS,
  bookedEntertainments,
});

const setBookedEntertainmentsFailure = error => ({
  type: SET_BOOKED_ENTERTAINMENTS_FAILURE,
  error,
});

export const clearBookedEntertainmentsErrorMessage = () => ({
  type: CLEAR_BOOKED_ENTERTAINMENTS_ERROR_MESSAGE,
});

export const getBookedEntertainments = (resId, siteCode) => async (dispatch, getState) => {
  dispatch(requestBookedEntertainments());
  const { config, bookingSearch } = getState();
  const { seasonSuffix = '' } = bookingSearch;
  const {
    REACT_APP_BOOKING_PREFIX: bookingPrefix,
    REACT_APP_BOOKING_SUBSCRIPTION_KEY: subscriptionKey,
    [`REACT_APP_LATEST_ACTIVITY_BOOKING_DATE${seasonSuffix}`]: latestActivityBookingDate,
    REACT_APP_API_TIMEOUT_MS: timeout,
  } = config;
  try {
    const { data = {} } = await callApi(
      {
        method: 'get',
        url: `/common/activity/reservation/list?ResId=${resId}&ParkCode=${siteCode.toUpperCase()}&pageSize=999`,
      },
      bookingPrefix,
      subscriptionKey,
      timeout,
    );
    const [bookedData = {}] = data.Data || [];
    const { BookedActivities = [] } = bookedData;
    const filteredBookedActivities = filterForBookedEventsOfThisBooking(BookedActivities);
    dispatch(receiveBookedEntertainments(filteredBookedActivities));
    dispatch(setBookedEntertainments(filteredBookedActivities, latestActivityBookingDate));
  } catch (error) {
    if (process.env.NODE_ENV === 'development') console.error(error); // eslint-disable-line
    dispatch(setBookedEntertainmentsFailure(error));
  }
};

export const setSelectedNumOfGuests = selectedNumOfGuests => ({
  type: SET_SELECTED_NUM_OF_GUESTS,
  selectedNumOfGuests,
});
